export type PlanLimits = {
  maxImages: number;
  maxRooms: number;
  maxImagesPerRoom: number;
};

/** Premium: up to 2 rooms, 3 images per room; remaining slots for location gallery (total 15). */
export function getPlanLimits(plan: string | null | undefined): PlanLimits {
  switch (plan) {
    case "premium":
      return { maxImages: 15, maxRooms: 2, maxImagesPerRoom: 3 };
    case "basic":
      return { maxImages: 3, maxRooms: 0, maxImagesPerRoom: 0 };
    default:
      return {
        maxImages: Infinity,
        maxRooms: Infinity,
        maxImagesPerRoom: Infinity,
      };
  }
}

type GalleryImage = {
  purpose?: string | null;
  mimetype?: string | null;
};

export function isPublicGalleryImage(img: GalleryImage): boolean {
  return (
    img.purpose !== "location_logo" &&
    img.purpose !== "location_contact_person_image" &&
    img.purpose !== "location_video" &&
    !img.mimetype?.startsWith("video/")
  );
}

export function filterPublicGalleryImages<T extends GalleryImage>(
  images: T[],
): T[] {
  return images.filter(isPublicGalleryImage);
}

export function limitImagesByPlan<T extends GalleryImage>(
  images: T[],
  plan: string | null | undefined,
): T[] {
  const { maxImages } = getPlanLimits(plan);
  const filtered = filterPublicGalleryImages(images);
  return maxImages === Infinity ? filtered : filtered.slice(0, maxImages);
}
